module.exports = __webpack_public_path__ + "static/Common_Lisp-041cd22b4d8b23da6f206b624ffd486c.png";